export const BRAND = {
  name: "THE RION",
  phone: "077 6 338 348",
  addressLines: ["No 15 Kandy Road", "Dalugama"],
  storageKey: "THE_RION",
  invoicePrefix: "TR",
  colors: {
    yellow: "#FEF200",
    black: "#000000",
  },
};

